<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div :class="isPrint ? 'grid grid-cols-12 gap-x-6 gap-y-4 mt-4' : 'grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4'">
      <div :class="isPrint ? 'col-span-2 flex items-center' : 'col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-2 flex items-center'" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.title }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.title }}
        </label>
      </div>
    </div>

    <!-- 표 -->
    <TableInspectMerge
      v-for="inspection in form.inspectList"
      :key="`inspection_${inspection.title}`"
      v-show="inspection.check"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="inspection.title"
      :tableHeaderTitle="inspection.tableHeaderTitle ? inspection.tableHeaderTitle : '착안사항'"
      v-model="inspection.list"
      class="mt-5"
    />

    <!--    기타점검내용-->
    <table class="mt-5">
      <tr>
        <th>점검내용</th>
      </tr>
      <tr>
        <td>
          <span v-if="isPrint" class="print-textarea"> {{ form.기타점검내용 }} </span>
          <ml-textarea v-else class="w-full" rows="5" v-model="form.기타점검내용" :readonly="board.readonly" />
        </td>
      </tr>
    </table>
<!--    <table-etc-check-->
<!--      title="기타점검내용"-->
<!--      :list="form.etcList"-->
<!--      table-header-title="착안사항"-->
<!--      table-header-yes="양호"-->
<!--      table-header-no="미흡"-->
<!--      table-header-na="해당없음"-->
<!--      @update-list-check="updateEtcListCheck"-->
<!--      @updateList="updateList"-->
<!--      @update-note="updateListNote"-->
<!--      :isPrint="isPrint"-->
<!--      :isReadonly="board.readonly"-->
<!--    />-->

    <!--    현장근로자 의견 청취 및 특이사항-->
    <div class="grid grid-cols-12 gap-x-6">
      <vs-row class="mt-8 col-span-12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-12 xl:col-span-4 flex items-center mt-4">
        <div class="label-text mr-4">현장근로자 의견 청취</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_1.fileName }}
        </p>
        <file-uploader v-else :readonly="board.readonly" v-model="form.inputC_1" class="flex-1 w-full" />
      </div>
      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">특이사항</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputC_2" :readonly="board.readonly" />
      </div>
    </div>

    <!-- 유해·위험요인 개선 결과 -->
    <ImprovementTable :readonly="board.readonly" :isPrint="isPrint" v-model="form.개선결과" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";
import TableInspectMerge from "@/components/TableInspectMerge";
import ImprovementTable from "../290/improvementTable.vue";

export default {
  components: {
    ImprovementTable,
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            if (key === "inspectList") {
              if (value[key].length < 13) {
                const itData = this.inspectTable.map((item, item_i) => {
                  if (!value[key][item_i]) return item;
                  const setData = { ...item, check: value[key][item_i].check };
                  setData.list = setData.list.map((list, list_i) => {
                    let _check = "";
                    if (value[key][item_i].list[list_i].is_checked === "Yes") _check = "양호";
                    else if (value[key][item_i].list[list_i].is_checked === "No") _check = "미흡";
                    else if (value[key][item_i].list[list_i].is_checked === "NA") _check = "해당없음";

                    return { ...list, isChecked: _check };
                  });
                  return setData;
                });
              }

              for (let i = 0; i < value[key].length; i++) {
                const item = value[key][i];
                if (item.title === "청소차량") {
                  let change = false;
                  const list = item.list.map((listItem) => {
                    let content = listItem.content;
                    if (content === "후방영상장칯 정상작동 여부") {
                      change = true;
                      content = "후방영상장치 정상작동 여부";
                    }
                    return {
                      ...listItem,
                      content,
                    };
                  });
                  if (change) {
                    value[key][i].list = list;
                  }
                }
              }
            }

            if (this.postId && key === "개선결과") {
              value[key].forEach((item) => {
                const 원본문자 = item.개선내용;

                // 담당자와 개선일자 있는지 검사
                const has담당자 = 원본문자.includes("- 담당자");
                const has개선일자 = 원본문자.includes("- 개선일자");

                if (has담당자 && has개선일자) {
                  console.log("원본", 원본문자);
                  // 값 추출
                  const 담당자Match = 원본문자.match(/- 담당자\s*:(.*)/);
                  const 개선일자Match = 원본문자.match(/- 개선일자\s*:(.*)/);
                  const 개선내용Match = 원본문자.match(/- 개선내용\s*:\s*([\s\S]*?)(?:- 개선일자|$)/);

                  const 담당자 = 담당자Match ? 담당자Match[1].trim() : null;
                  const 개선일자 = 개선일자Match ? 개선일자Match[1].trim() : null;
                  const 개선내용 = 개선내용Match ? 개선내용Match[1].trim() : "";

                  item.개선내용담당자 = 담당자;
                  item.개선내용개선일자 = 개선일자;
                  item.개선내용 = 개선내용;
                }
              });
            }

            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateEtcListCheck(row, text) {
      this.form.etcList[row].checked = text;
    },
    updateListNote(row, text) {
      this.form.etcList[row].note = text;
    },
    updateList(list) {
      this.form.etcList = list;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
        etcList: [],
        개선결과: [],

        기타점검내용: "",
      },
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    inspectTable() {
      return [
        {
          check: false,
          title: "정리정돈",
          list: [
            {
              content: "1. 작업장(현장) 정리정돈 상태는?",
              isChecked: "",
            },
            {
              content: "2. 공구 및 기계의 정비 및 정리정돈 상태는?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "화재방지",
          list: [
            {
              content: "1. 작업현장 근처에 가연성물질,인화성물질이 있는가?",
              isChecked: "",
            },
            {
              content: "2. 작업 전 가스, 분진 및 환기상태 여부 확인하는가?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "추락재해방지",
          list: [
            {
              content: "1. 추락위험이 있는 장소에 작업발판이 설치되어 있는가?",
              isChecked: "",
            },
            {
              content: "2. 바닥면에서 높이 1m이상인 계단의 개방된 측면에 안전난간이 설치되어 있는가?",
              isChecked: "",
            },
            {
              content: "3. 기계기구 또는 설비에 설치한 방호장치를 임의해체하거나 기능을 해제한 상태로 사용하는가?",
              isChecked: "",
            },
            {
              content: "4. 끼임 위험이 있는 원동기, 회전축, 기어 및 체인에 대한 방호장치의 유무 및 유지관리 여부",
              isChecked: "",
            },
            {
              content: "5. 동력으로 작동되는 기계에 스위치, 클러치, 벨트이동장치 등 동력차단장치 설치 유무",
              isChecked: "",
            },
            {
              content: "6. 수리, 점검, 청소, 세척 작업시 전원은 차단하고 작업하는가?",
              isChecked: "",
            },
            {
              content: "7. 위험기계 작업전 안전교육 실시 여부",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "끼임재해방지",
          list: [
            {
              content: "1. 위험기계기구에 적합한 방호장치를 설치하고 있으며, 안전인증·안전검사 대상인 경우 인증 또는 검사를 받고 사용하고 있는가?",
              isChecked: "",
            },
            {
              content: "2. 위험기계기구의 방호조치 등의 기능이 유지되고 있는가?",
              isChecked: "",
            },
            {
              content: "3. 기계기구 또는 설비에 설치한 방호장치를 임의해체하거나 기능을 해제한 상태로 사용하는가?",
              isChecked: "",
            },
            {
              content: "4. 끼임 위험이 있는 원동기, 회전축, 기어 및 체인에 대한 방호장치의 유무 및 유지관리 여부",
              isChecked: "",
            },
            {
              content: "5. 동력으로 작동되는 기계에 스위치, 클러치, 벨트이동장치 등 동력차단장치 설치 유무",
              isChecked: "",
            },
            {
              content: "6. 수리, 점검, 청소, 세척 작업시 전원은 차단하고 작업하는가?",
              isChecked: "",
            },
            {
              content: "7. 위험기계 작업전 안전교육 실시 여부",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "넘어짐·베임방지",
          list: [
            {
              content: "1. 이동시 바닥의 상태, 턱, 장애물 유무 확인하는가?",
              isChecked: "",
            },
            {
              content: "2. 물건이동시 날카로움, 베일 우려가 있는지 확인하는가?",
              isChecked: "",
            },
            {
              content: "3. 계단끝단 미끄럼방지조치, 계단난간 설치 및 이동통로에 적정 조도는 확보되었는가?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "보호구",
          list: [
            {
              content: "1. 적절한 보호구는 지급하고 있는가?",
              isChecked: "",
            },
            {
              content: "2. 적절한 보호구는 착용하고 있는가?",
              isChecked: "",
            },
            {
              content: "3. 보호구는 주기적인 점검 및 교체 여부",
              isChecked: "",
            },
            {
              content: "4. 보호구 지급대장 작성하고 있는가?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "안전점검 및 검사",
          tableHeaderTitle: [{ text: "착안사항", colspan: 3 }],
          list: [
            {
              content: [
                "위험기계·기구설비 안전검사",
                [
                  {
                    content: "리프트",
                    check: false,
                  },
                  {
                    content: "크레인",
                    check: false,
                  },
                  {
                    content: "곤도라",
                    check: false,
                  },
                  {
                    content: "전단기",
                    check: false,
                  },
                  {
                    content: "압력용기",
                    check: false,
                  },
                  {
                    content: "프레스",
                    check: false,
                  },
                  {
                    content: "로울러기",
                    check: false,
                  },
                  {
                    content: "사출성형기",
                    check: false,
                  },
                  {
                    content: "국소배기장치",
                    check: false,
                  },
                  {
                    content: "컨베이어",
                    check: false,
                  },
                  {
                    content: "원심기",
                    check: false,
                  },
                  {
                    content: "산업용 로봇",
                    check: false,
                  },
                  {
                    content: "고소작업대",
                    check: false,
                  },
                ],
                "최초 설치 후 3년 이내 1회, 이후 2년 1회",
              ],
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "방호장치가 필요한 기계·기구",
          tableHeaderTitle: [{ text: "착안사항", colspan: 2, widths: ["auto", "300"] }],
          list: [
            {
              content: [
                [
                  {
                    content: "예초기",
                    check: false,
                  },
                  {
                    content: "원심기",
                    check: false,
                  },
                  {
                    content: "공기압축기",
                    check: false,
                  },
                  {
                    content: "금속절단기",
                    check: false,
                  },
                  {
                    content: "지게차",
                    check: false,
                  },
                  {
                    content: "진공포장기",
                    check: false,
                  },
                  {
                    content: "랩핑기",
                    check: false,
                  },
                ],
                "동력으로 작동하는 기계·기구",
              ],
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "전기기계기구",
          list: [
            {
              content: "1. 전기기계기구 사용 중 누전에 의한 감전사고 발생의 위험은 없는가?",
              isChecked: "",
            },
            {
              content: "2. 물기가 많은 습윤한 장소, 바닥에서 전기기계기구 사용 중 감전사고 발생의 위험은 없는가?",
              isChecked: "",
            },
            {
              content: "3. 전기기계기구의 전선피복 절연상태는 양호한가?",
              isChecked: "",
            },
            {
              content: "4. 전선의 피복 손상은 있는가?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "이동식 사다리",
          list: [
            {
              content: "1. 사다리는 평탄·견고하고 미끄럼이 없는 바닥에서 사용하는가?",
              isChecked: "",
            },
            {
              content: "2. 작업높이 3.5m이하로 작업하고 있는가?",
              isChecked: "",
            },
            {
              content: "3. 안전모 착용하고 작업하는가?",
              isChecked: "",
            },
            {
              content: "4. 1.2m이상 작업시 2인1조 작업하고 있는가?",
              isChecked: "",
            },
            {
              content: "5. 최상부 발판에서 작업금지하고 있는가?",
              isChecked: "",
            },
            {
              content: "6. 작업높이 2m이상인 경우 안전대 착용하고 있는가?",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "도로보수",
          list: [
            {
              content: "작업지휘자(유도자) 배치 ",
              isChecked: "",
            },
            {
              content: "작업중 입간판(안내판) 설치",
              isChecked: "",
            },
            {
              content: "차량 위험·경고등 작동",
              isChecked: "",
            },
            {
              content: "신호수 배치",
              isChecked: "",
            },
            {
              content: "반사안전조끼 착용",
              isChecked: "",
            },
            {
              content: "15Kg 이상은 2인1조 작업",
              isChecked: "",
            },
            {
              content: "작업시간 조정",
              isChecked: "",
            },
            {
              content: "충분한 음료섭취 및 휴식",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "청소차량",
          list: [
            {
              content: "보호구 지급 및 활용",
              isChecked: "",
            },
            {
              content: "경광등 정상작동 여부",
              isChecked: "",
            },
            {
              content: "후방영상장치 정상작동 여부",
              isChecked: "",
            },
            {
              content: "양수조작 스위치 정상작동 여부",
              isChecked: "",
            },
            {
              content: "차량 등화류 정상작동 여부",
              isChecked: "",
            },
            {
              content: "유압장치 작동유 유량 적정 여부",
              isChecked: "",
            },
            {
              content: "차량 엔진오일, 타이어 공기압 적정 여부",
              isChecked: "",
            },
            {
              content: "차량 전면 유리창, 후방조사경 청결 여부",
              isChecked: "",
            },
          ],
        },
        {
          check: false,
          title: "청소차량 및 환경미화원",
          list: [
            {
              content: "사무실 콘센트, 소화기 및 냉난방 상태 등",
              isChecked: "",
            },
            {
              content: "차고지 출구 운전 상태, 주의운전 여부 및 고임목 설치 여부 등",
              isChecked: "",
            },
            {
              content: "샤워장 미끄럼 방지 및 청결유지 상태",
              isChecked: "",
            },
            {
              content: "안전보건교육 실시",
              isChecked: "",
            },
            {
              content: "건강검진(채용전 포함)에 관한 사항",
              isChecked: "",
            },
            {
              title: "종량제봉투 수집 운반",
              content: "수거에 관한 사항",
              isChecked: "",
            },
            {
              title: "종량제봉투 수집 운반",
              content: "상차 적재에 관한 사항",
              isChecked: "",
            },
            {
              title: "종량제봉투 수집 운반",
              content: "청소차 이동에 관한 사항",
              isChecked: "",
            },
            {
              title: "종량제봉투 수집 운반",
              content: "자원회수시설에 관한 사항",
              isChecked: "",
            },
            {
              title: "음식물쓰레기 수집 운반",
              content: "배출장소 이동 및 수거에 관한 사항",
              isChecked: "",
            },
            {
              title: "음식물쓰레기 수집 운반",
              content: "음식물쓰레기 등 상차 및 이적에 관한 사항",
              isChecked: "",
            },
            {
              title: "음식물쓰레기 수집 운반",
              content: "수거차량 이동에 관한 사항",
              isChecked: "",
            },
            {
              title: "재활용품 수집 운반",
              content: "배출장소 이동 및 수거에 관한 사항",
              isChecked: "",
            },
            {
              title: "재활용품 수집 운반",
              content: "재활용품 등 상차 및 이적에 관한 사항",
              isChecked: "",
            },
            {
              title: "재활용품 수집 운반",
              content: "수거차량 이동에 관한 사항",
              isChecked: "",
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
$mobile-breakpoint: 768px;

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    font-size: 14px;
  }
  th {
    font-weight: 500;
    text-align: center;
    background: #f9f9f9;
    padding: 8px;
  }
  td {
    font-weight: 400;
    padding: 4px;
  }
}

/* 반응형 레이아웃 제어 */
@media (max-width: $mobile-breakpoint) {
  /* 모바일에서는 체크박스를 세로로 배치 */
  .grid {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }

  .col-span-12.sm\:col-span-6.md\:col-span-4.xl\:col-span-2,
  .col-span-2 {
    grid-column: span 1 / span 1 !important;
    margin-bottom: 8px;
  }

  /* 모바일 체크박스 스타일 */
  .flex.items-center {
    padding: 12px 16px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 8px;
    transition: all 0.2s ease;

    &:hover {
      background: #f9fafb;
      border-color: #d1d5db;
    }

    label {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      min-height: 20px;

      .vs-checkbox {
        margin-right: 12px;
      }
    }
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  /* 체크박스 그리드를 PC 버전으로 강제 설정 */
  .grid {
    display: grid !important;
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  /* 체크박스 아이템을 2컬럼으로 강제 설정 */
  .col-span-2,
  .col-span-12.sm\:col-span-6.md\:col-span-4.xl\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
}
</style>
